import moment from "moment";
import { LoadState } from "../../constants/enums";
import {
  IServiceInvoice,
  IServiceInvoiceItem,
  IServiceInvoiceState,
} from "./service-invoice.types";
import { defaultServiceOrderItem } from "../service-order";

export const defaultServiceInvoiceItem: IServiceInvoiceItem = {
  ...defaultServiceOrderItem,
  service_order_uuid: "",
  service_order_no: "",

  category_head_uuid: null,
  category_head_name: null,
  expense_category_uuid: null,
  expense_category_name: null,
};

export const defaultServiceInvoice: IServiceInvoice = {
  service_invoice_uuid: null,
  service_invoice_type: "",
  service_invoice_date: moment().format("YYYY-MM-DD"),
  service_invoice_no: "",
  expense_type: "",
  expense_subtype: "",
  payment_type: "FULL",

  service_order_uuid: null,
  service_order_no: null,
  service_order_date: "",
  project_uuid: "",
  project_name: "",
  project_manager_uuid: "",
  project_manager_name: "",

  challan_no: null,
  challan_date: null,
  eway_bill_no: null,
  lr_no: null,
  delivery_note: null,
  mode_of_payment: null,
  reference_no: null,
  other_references: null,
  buyers_order_no: null,
  dispatch_doc_no: null,
  delivery_note_date: null,
  dispatched_through: null,
  destination: null,
  bill_of_lading: null,
  motor_vehicle_no: null,
  products: [],

  billing_company_uuid: null,
  billing_company_name: null,
  billing_company_branch_uuid: null,
  billing_company_branch_name: null,
  billing_company_address_line1: null,
  billing_company_address_line2: null,
  billing_company_address_city: null,
  billing_company_address_state: null,
  billing_company_address_country: null,
  billing_company_GSTIN: null,
  billing_company_code: null,
  billing_company_address_pincode: null,

  vendor_uuid: null,
  vendor_name: null,
  vendor_email: null,
  vendor_phone_number: null,
  vendor_contact_name: null,
  vendor_registration_type: null,
  vendor_GSTIN: null,
  vendor_code: null,

  vendor_address_line1: null,
  vendor_address_line2: null,
  vendor_address_city: null,
  vendor_address_state: null,
  vendor_address_country: null,
  vendor_address_pincode: null,

  dispatch_through: null,
  transport_id: null,
  transport_doc_no: null,
  transport_doc_date: null,
  bank_account_uuid: null,
  bank_account_name: null,
  rev_charge: null,
  consignee_phone_number: null,
  consignee_email: null,
  distance_from_eway: null,

  attachments: [],
  service_line_items: [],
  payment_splits: [],

  sub_total: 0,
  tax_amount: 0,
  total_amount_after_tax: 0,
  tds: 0,
  tds_amount: 0,
  discount: 0,
  discount_amount: 0,
  total: 0,
  is_round_off: 0,
  outstanding_amount: 0,

  term_and_conditions: null,
  payment_terms: null,
  addtional_clauses_or_conditions: null,
  remark: null,

  status: "ACTIVE",
};

export const defaultServiceInvoiceState: IServiceInvoiceState = {
  service_invoice_list: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
  },
  single_service_invoice: {
    data: defaultServiceInvoice,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
